import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import "./styles/index.less";
//Layout Principale
import DashboardMainLayout from "./components/dashboardMainLayout/DashboardMainLayout";
//pages

import {
  adminDashboardRoute,
  commonRoutes,
  userDashboardRoute,
} from "./utils/routes/Routes";
import { UserLoginForm } from "./components/webSections/userLogin/UserLoginForm";
import { useTokenVerify } from "./utils/hooks/useTokenVerify";
import { useEffect } from "react";
import { useGetUserSettingsByIdQuery } from "./redux/features/settings/setttingsApi";
import { Skeleton } from "@mui/material";
import checkIfRoleIsAllowed from "./utils/hooks/checkIfRoleIsAllowed";
import UsersPage from "./components/dashboardSections/backoffice/users/UsersPage";
import ContactPage from "./components/webSections/contactPage/ContactPage";
import WebMainLayout from "./components/webMainLayout/WebMainLayout";
import "./styles/index.less";
import { SingleUserPage } from "./components/dashboardSections/backoffice/users/projects/SingleUserPage";
import { ProjectDetails } from "./components/dashboardSections/backoffice/users/projects/ProjectDetails";
import DashboardAdminOperations from "./components/dashboardSections/backoffice/dashboard/DashboardAdmin";
import TicketsPage from "./components/dashboardSections/backoffice/tickets/TicketsPage";
import { SingleTicketPage } from "./components/dashboardSections/backoffice/tickets/SingleTicketPage";
import NewProject from "./components/dashboardSections/frontoffice/projects/NewProject";
import BuyCreditsPage from "./components/dashboardSections/frontoffice/buyCredits/BuyCreditsPage";
import BuyCreditsCheckoutPage from "./components/dashboardSections/frontoffice/buyCredits/BuyCreditsCheckoutPage";
import SuccessPage from "./components/dashboardSections/frontoffice/redirectPages/SuccessPage";
import ErrorPage from "./components/dashboardSections/frontoffice/redirectPages/ErrorPage";
import RegistrationPage from "./components/webSections/userLogin/RegistrationPage";
import SingleProjectPage from "./components/dashboardSections/frontoffice/projects/SingleProjectPage";
import ProjectsPage from "./components/dashboardSections/frontoffice/projects/ProjectsPage";
import NewTicket from "./components/dashboardSections/frontoffice/tickets/NewTicket";
import UserTicketsPage from "./components/dashboardSections/frontoffice/tickets/UserTicketsPage";
import { SingleUserTicketPage } from "./components/dashboardSections/frontoffice/tickets/SingleUserTicketPage";
import { SettingsPage } from "./components/dashboardSections/backoffice/settings/SettingsPage";
import ChangePasswordPage from "./components/webSections/userLogin/ChangePasswordPage";
import FaqPage from "./components/dashboardSections/backoffice/faq/FaqPage";
import DashboardUser from "./components/dashboardSections/frontoffice/dashboard/DashboardUser";
import UserFaqPage from "./components/dashboardSections/frontoffice/faq/UserFaqPage";
import { useAuthDeviceQuery } from "./redux/features/auth/authApi";
import {
  setDeviceId,
  setUserSettings,
} from "./redux/features/settings/settingsSlice";
import Profile from "./components/dashboardSections/common/profile/Profile";

export const App = () => {
  // HOOKS
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // REDUX

  const {
    role,
    user_id: userId,
    username,
    active,
    expired,
    isLoading,
  } = useTokenVerify(); // chiama lo useEffect dentro all'hook: controlla il token

  const {
    data: deviceSettings,
    isError: isDeviceError,
    isLoading: isDeviceLoading,
  } = useAuthDeviceQuery();

  const {
    data: userSettings,
    isError,
    isLoading: isSettingsLoading,
  } = useGetUserSettingsByIdQuery(deviceSettings?.device_id, {
    skip: !deviceSettings,
  });

  //USE EFFECT
  useEffect(() => {
    if (deviceSettings && !isDeviceLoading && !isDeviceError) {
      dispatch(setDeviceId(deviceSettings.device_id));
    }
    if (userSettings && !isSettingsLoading && !isError) {
      dispatch(setUserSettings(userSettings));
    }
  }, [
    userSettings,
    dispatch,
    isSettingsLoading,
    isError,
    deviceSettings,
    isDeviceLoading,
    isDeviceError,
  ]);

  useEffect(() => {
    // const isRoleAllowedHere = checkIfRoleIsAllowed(location.pathname, role);

    if (isLoading) {
      return;
    }
    if (!userId || expired) {
      // al momento ricado in questa casistica perchè quando ricarico la pagina
      // redux si resetta e di conseguenza anche il token
      // // navigate(commonRoutes.login);
    } else if (!role) {
      // se ancora l'utente non ha un ruolo (poichè non loggato) lo useEffect si interrompe e lui può navigare nella parte web
      // es. alla pagina dei contatti
      return;
    }
  }, [expired, role, location.pathname, navigate]);

  if (isSettingsLoading) {
    return <Skeleton />; // da fixare, non si vede lo skeleton, si vede solo bianco
  }

  function CheckRole({ roles, children }) {
    if (role && !isLoading && roles.includes(role)) {
      return children;
    } else {
      return <Navigate to={commonRoutes.login} />;
    }
  }

  return (
    <Routes>
      {/* DASHBOARD ROUTES */}
      <Route
        path="/"
        element={
          <CheckRole roles={["admin", "user"]}>
            <DashboardMainLayout />
          </CheckRole>
        }
      >
        <Route
          path={adminDashboardRoute.dashboardHome}
          element={
            <CheckRole roles={["admin"]}>
              <DashboardAdminOperations />
            </CheckRole>
          }
        />

        <Route
          path={adminDashboardRoute.users}
          element={
            <CheckRole roles={["admin"]}>
              <UsersPage />
            </CheckRole>
          }
        >
          <Route
            path={":id"}
            element={
              <CheckRole roles={["admin"]}>
                <SingleUserPage />
              </CheckRole>
            }
          >
            <Route
              path={"projects/:projectId"}
              element={
                <CheckRole roles={["admin"]}>
                  <ProjectDetails />
                </CheckRole>
              }
            ></Route>
          </Route>
        </Route>
        <Route
          path={adminDashboardRoute.tickets}
          element={
            <CheckRole roles={["admin"]}>
              <TicketsPage />
            </CheckRole>
          }
        >
          <Route
            path={":id"}
            element={
              <CheckRole roles={["admin"]}>
                <SingleTicketPage />
              </CheckRole>
            }
          ></Route>
        </Route>
        <Route
          path={adminDashboardRoute.faq}
          element={
            <CheckRole roles={["admin"]}>
              <FaqPage />
            </CheckRole>
          }
        />
        <Route
          path={adminDashboardRoute.settings}
          element={
            <CheckRole roles={["admin"]}>
              <SettingsPage />
            </CheckRole>
          }
        />
        <Route
          path={adminDashboardRoute.profile}
          element={
            <CheckRole roles={["admin"]}>
              <Profile />
            </CheckRole>
          }
        />
        <Route
          path={userDashboardRoute.dashboardHome}
          element={
            <CheckRole roles={["user"]}>
              <DashboardUser />
            </CheckRole>
          }
        />

        <Route
          path={userDashboardRoute.projects}
          element={
            <CheckRole roles={["user"]}>
              <ProjectsPage />
            </CheckRole>
          }
        >
          <Route
            path={":projectId"}
            element={
              <CheckRole roles={["user"]}>
                <SingleProjectPage />
              </CheckRole>
            }
          />
        </Route>
        <Route
          path={userDashboardRoute.newProject}
          element={
            <CheckRole roles={["user"]}>
              <NewProject />
            </CheckRole>
          }
        />
        <Route
          path={userDashboardRoute.tickets}
          element={
            <CheckRole roles={["user"]}>
              <UserTicketsPage />
            </CheckRole>
          }
        >
          <Route
            path={":id"}
            element={
              <CheckRole roles={["user"]}>
                <SingleUserTicketPage />
              </CheckRole>
            }
          />
        </Route>
        <Route
          path={userDashboardRoute.newTicket}
          element={
            <CheckRole roles={["user"]}>
              <NewTicket />
            </CheckRole>
          }
        />

        <Route
          path={userDashboardRoute.buyCredits}
          element={
            <CheckRole roles={["user"]}>
              <BuyCreditsPage />
            </CheckRole>
          }
        />
        <Route
          path={userDashboardRoute.buyCreditsCheckout}
          element={
            <CheckRole roles={["user"]}>
              <BuyCreditsCheckoutPage />
            </CheckRole>
          }
        />
        <Route
          path={userDashboardRoute.faq}
          element={
            <CheckRole roles={["user"]}>
              <UserFaqPage />
            </CheckRole>
          }
        />
        <Route
          path={userDashboardRoute.profile}
          element={
            <CheckRole roles={["user"]}>
              <Profile />
            </CheckRole>
          }
        />

        <Route
          path={userDashboardRoute.successPage}
          element={
            <CheckRole roles={["user"]}>
              <SuccessPage />
            </CheckRole>
          }
        />
        <Route
          path={userDashboardRoute.errorPage}
          element={
            <CheckRole roles={["user"]}>
              <ErrorPage />
            </CheckRole>
          }
        />
      </Route>
      {/* WEB ROUTES */}
      <Route path="/" element={<WebMainLayout />}>
        <Route path={commonRoutes.contacts} element={<ContactPage />} />
        <Route
          path={commonRoutes.login}
          element={<UserLoginForm userSettings={userSettings} />}
        />
        <Route path={commonRoutes.register} element={<RegistrationPage />} />
        <Route
          path={commonRoutes.firstLogin}
          element={<ChangePasswordPage />}
        />
        <Route
          path={commonRoutes.notFound}
          element={
            <CheckRole roles={["admin", "user"]}>
              <div>Not found</div>
            </CheckRole>
          }
        />
      </Route>
      <Route
        path="*"
        element={
          <CheckRole roles={["admin", "user"]}>
            <div>Not found</div>
          </CheckRole>
        }
      />
    </Routes>
  );
};
